
import {adopt} from 'react-adopt';
import {makeMutation} from '@util/ContainerUtils';
import {
    UpdateReviewStatus,
    UpdateReviewVotes,
    UpdateReviewResponse
} from '@services/BrandReviews/query.graphql';

export const ReviewsApiContainer = adopt( {
    updateReviewStatus: makeMutation( {mutation: UpdateReviewStatus} ),
    updateReviewResponse: makeMutation( {mutation: UpdateReviewResponse} ),
    updateReviewVotes: makeMutation( {mutation: UpdateReviewVotes} )
} );